module.exports = __webpack_public_path__ + "static/media/ic-address.0a6cdc57.svg";